export default "<!--page-title-->\n<div class=\"row my-4\">\n  <div class=\"col\">\n    <h1 class=\"page-title\">Files (Mockup)</h1>\n  </div>\n</div>\n"